import { render } from "./GridCardFuncionario.vue?vue&type=template&id=2b71a25e&scoped=true"
import script from "./GridCardFuncionario.vue?vue&type=script&lang=js"
export * from "./GridCardFuncionario.vue?vue&type=script&lang=js"

import "./GridCardFuncionario.vue?vue&type=style&index=0&id=2b71a25e&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\apontamentowebvueV3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b71a25e"]])

export default __exports__